import VsCompare from "./VsCompare";

export default function VsKvcore() {
  return (
    <VsCompare
      competitor="kvCORE"
      testId="vs-kv-page"
      slug="kvcore"
      seoTitle="iKEY vs. kvCORE — Solo-Agent Pricing, DocuSign Included"
      seoDescription="Compare iKEY and kvCORE. Solo agents sign up online for iKEY today; kvCORE is brokerage-only. DocuSign is included on every iKEY paid plan."
      tagline="kvCORE is a brokerage platform. iKEY is a solo-agent workspace."
      rows={[
        { label: "Free forever tier",             ikey: true,                    them: false },
        { label: "E-signatures included",         ikey: "DocuSign built-in",     them: "Add-on (dotloop / DocuSign)" },
        { label: "AI 'Who to call today' briefing", ikey: true,                  them: "Behavioral automation (rules)" },
        { label: "Branded client portal",         ikey: true,                    them: "IDX consumer site" },
        { label: "Native iOS + Android app",      ikey: true,                    them: true },
        { label: "Priced for one agent",          ikey: true,                    them: "Brokerage-only pricing" },
        { label: "Set up in under 2 minutes",     ikey: true,                    them: "Onboarding call + IDX config" },
        { label: "CSV data export on Free",       ikey: true,                    them: "No free tier" },
      ]}
      pricing={[
        { tier: "Free",             ikey: "$0 · 1–3 clients (CRM only)",     them: "No free tier" },
        { tier: "Entry paid tier",  ikey: "$39.99/mo · Growth · 10 clients", them: "$500+/mo · Solo Agent (brokerage-negotiated)" },
        { tier: "Mid-tier",         ikey: "$79.99/mo · Master · 20 clients", them: "Bundled into brokerage seat fee" },
        { tier: "Top tier",         ikey: "$119.99/mo · Pro · unlimited",    them: "$1,000+/mo · Team / Brokerage" },
        { tier: "DocuSign add-on",  ikey: "Included in every paid plan",     them: "$45–$85/mo extra (DocuSign)" },
      ]}
      chooseIkeyWhen={[
        "You're an independent or solo agent — kvCORE is priced for a brokerage seat, not a solo book.",
        "You want to sign up online today — kvCORE requires a brokerage relationship, an onboarding call, and IDX config before you touch the product.",
        "You want AI briefings, not another rules-based automation builder — iKEY tells you who to call this morning; kvCORE hands you a workflow canvas.",
        "You want DocuSign included — kvCORE routes e-signatures through a bring-your-own DocuSign or dotloop plan with its own price tag.",
        "You want a branded client portal, not an IDX consumer site — iKEY's portal is a per-client deal room, not a public property search.",
      ]}
      faq={[
        {
          q: "Can I migrate my kvCORE data into iKEY?",
          a: "Yes. Ask your brokerage admin to export leads and contacts from kvCORE as CSV, then drop the file into iKEY's Import CSV screen on the Leads page.",
        },
        {
          q: "Does iKEY replace kvCORE's IDX consumer site?",
          a: "iKEY doesn't ship a public IDX search — it ships a branded portal per client with tailored listing pushes. Different problem: iKEY assumes the lead is already in your pipeline; kvCORE spends its budget attracting them.",
        },
        {
          q: "Is iKEY's DocuSign the real DocuSign?",
          a: "Yes — the same DocuSign envelopes, certificates, and audit trail; you just don't manage a separate DocuSign subscription.",
        },
        {
          q: "How much cheaper is iKEY over a year?",
          a: "kvCORE's Solo Agent access typically starts at $500/mo through a brokerage plus a $45/mo DocuSign line item — around $6,540/year. iKEY Growth is $479.88/year — roughly $6,000 saved. Annual billing on iKEY drops that another 18%.",
        },
      ]}
    />
  );
}
